// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseMutationResult, useMutation } from '@tanstack/react-query';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import { useParties } from '../../../../contexts/PartiesContext';

const useRequestRegistrarService: () => UseMutationResult<
  void,
  string,
  { upgrader: string }
> = () => {
  const ledgerApi = useLedgerApiClient();
  const { operator, party } = useParties();

  return useMutation({
    mutationKey: ['requestRegistryRegistrarService', ledgerApi, operator, party],
    mutationFn: async ({ upgrader }) => {
      return ledgerApi.requestRegistryRegistrarService(operator, party, upgrader);
    },
    retry: false,
  });
};

export default useRequestRegistrarService;
